import web from "../web";

class SexesService {
    index(token){
        return web.get("/api/sexes", { headers: { 'Authorization': 'Bearer '+token } })
    }
    store(data, token){
        return web.post("/api/sexes", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/sexes/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/sexes/update", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/sexes/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new SexesService()